import api from "../modules/shared/helpers/api";

const authStore = {
  namespaced: true,
  state: () => ({
    user: null,
    token: null,
  }),
  mutations: {
    updateUser(state, user) {
      state.user = user;
    },
    updateToken(state, token) {
      state.token = token;
    },
  },
  getters: {
    isLogged(state) {
      return !!state.user;
    },
  },
  actions: {
    login({ commit }, { user, token }) {
      localStorage.setItem("user", JSON.stringify(user));
      localStorage.setItem("token", token);
      api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
      commit("updateUser", user);
      commit("updateToken", token);
    },
    load({ commit }) {
      const user = localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : null;
      const token = localStorage.getItem("token") || null;

      if (user && token) {
        api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
        commit("updateUser", user);
        commit("updateToken", token);
      }
    },
    logout({ commit }) {
      localStorage.removeItem("user");
      localStorage.removeItem("token");
      commit("updateUser", null);
      commit("updateToken", null);
    },
  },
};

export default authStore;
